import React from "react";
import { Row, Col, Button, Typography, Space, message } from "antd";
import Scrollbars from "react-custom-scrollbars";
import InfiniteScroll from "react-infinite-scroll-component";
import { UpOutlined, DownOutlined } from "@ant-design/icons";
import Back from "../../../../assets/images/backIcon.svg";
import defaultImage from "../../../../assets/images/no-image.svg";
import Offers from "../../../../assets/images/promoTag.svg";
import { getMultilingualText } from "../../../../utils/getMultilingualText";
import { v4 as uuidv4 } from "uuid";
import dayjs from "dayjs";
import useSessionStore from "../../../../stores/useSessionStore";
import useRestaurantStore from "../../../../stores/useRestaurantStore";

const { Text } = Typography;

const SplitBillScreen = ({
  splitCarts,
  setSplitCarts,
  splitBillScreen,
  setSplitBillScreen,
  numSplits,
  setNumSplits,
  showAllItems,
  setShowAllItems,
  setIsSplitBill,
  setCurrentSplitIndex,
  groupedItems,
  openCategory,
  toggleCategory,
  categorySplitSelection,
  setCategorySplitSelection,
  itemSplitMap,
  setItemSplitMap,
  assignWholeCategory,
  handleToggleItemSplit,
  currenciesList,
  pricePrecision,
  toFixedTruncate,
  selectedProductId,
  userPreferences,
  serviceChargeAmount,
  tipTotal,
  deliveryCharge,
  packingCharge,
  setPaymentVisible,
  setRemoveSplit,
  setAmount,
  setCart,
  recordState,
}) => {
  return (
    <div style={{ padding: "10px 0px 10px 15px", fontSize: "1vw", overflow: "hidden" }}>
      <Row style={{ display: "flex", alignItems: "center" }}>
        <img
          src={Back}
          style={{
            height: "4vh",
            cursor: "pointer",
            paddingBottom: "0.1em",
          }}
          onClick={() => {
            const unpaidSplits = splitCarts.length;
            const paidSplits = numSplits - unpaidSplits;

            if (paidSplits > 0 && unpaidSplits > 0) {
              message.warning("Please complete payment for remaining splits");
              return;
            }
            setCategorySplitSelection({});
            setItemSplitMap({});
            setSplitBillScreen(false);
            setNumSplits(2);
            setIsSplitBill(false);
            setSplitCarts([]);
            setCurrentSplitIndex(0);
            setShowAllItems(true);
          }}
        />
        <p style={{ marginBottom: 0, paddingLeft: "4px", color: "#0F0718", fontSize: "1.5em", fontWeight: 500 }}>Split Bill</p>
      </Row>
      <Row style={{ marginTop: "2vh" }}>
        {showAllItems ? (
          <Col span={6} style={{ border: "1px solid #ccc", height: "83vh", borderRadius: "7px", backgroundColor: "#fff" }}>
            <p style={{ marginBottom: 0, fontSize: "1.25em", fontWeight: 500, color: "#0F0718", textAlign: "left", padding: "10px 10px 0 20px" }}>All Items </p>
            <p style={{ marginBottom: 0, fontSize: "0.8em", fontWeight: 300, color: "#929098", textAlign: "left", padding: "0 10px 0 20px" }}>
              Assign entire categories or individual items to splits
            </p>

            <Scrollbars autoHide style={{ height: "75vh", marginTop: "1vh" }}>
              <div style={{ padding: "0px 15px 10px 15px" }}>
                {groupedItems.map((group, gIndex) => (
                  <div
                    key={gIndex}
                    style={{
                      border: "1px solid #E0E0E0",
                      borderRadius: "8px",
                      marginBottom: "15px",
                      background: "transparent",
                    }}
                  >
                    <div
                      style={{
                        border: "1px solid #E0E0E0",
                        borderRadius: "8px",
                        overflow: "hidden",
                      }}
                    >
                      {/* HEADER */}
                      <div
                        style={{
                          padding: "10px 10px",
                          cursor: "pointer",
                        }}
                        onClick={() => toggleCategory(gIndex)}
                      >
                        {/* HEADER CLICK ROW */}
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <div>
                            <p style={{ marginBottom: 0, fontWeight: 600, fontSize: "1em", color: "#0F0718" }}>{group.category}</p>

                            <p
                              style={{
                                fontSize: "0.9em",
                                color: "#929098",
                                margin: "0 0 0 0",
                              }}
                            >
                              {group.items.length} items · {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                              {group.items.reduce((s, i) => s + i.nettotal, 0).toFixed(2)}
                              {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol} ` : ""}
                            </p>
                          </div>

                          <span style={{ fontSize: "12px", color: "#2F3856", paddingRight: "0.5vw" }}>{openCategory === gIndex ? <UpOutlined /> : <DownOutlined />}</span>
                        </div>

                        <div style={{ marginTop: "2px" }}>
                          <p
                            style={{
                              marginBottom: "6px",
                              fontSize: "0.8em",
                              color: "#929098",
                            }}
                          >
                            Quick assign entire category:
                          </p>
                          <div style={{ display: "flex", gap: "8px" }}>
                            {[...Array(numSplits)].map((_, idx) => {
                              const isSelected = categorySplitSelection[group.category] === idx;

                              return (
                                <button
                                  key={idx}
                                  style={{
                                    background: isSelected ? "#fff" : "#2F3856",
                                    color: isSelected ? "#2F3856" : "#fff",
                                    border: "1px solid #2F3856",
                                    borderRadius: "20px",
                                    padding: "2.5px 10px",
                                    fontSize: "0.8em",
                                    cursor: "pointer",
                                    textAlign: "center",
                                  }}
                                  onClick={() => {
                                    const undo = categorySplitSelection[group.category] === idx;

                                    assignWholeCategory(group, idx, undo);

                                    setCategorySplitSelection((prev) => (undo ? { ...prev, [group.category]: undefined } : { ...prev, [group.category]: idx }));
                                  }}
                                >
                                  Split {idx + 1}
                                </button>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* WHEN CATEGORY EXPANDED */}
                    {openCategory === gIndex && (
                      <>
                        {group.items.map((item, index) => (
                          <div
                            key={index}
                            style={{
                              border: "1px solid #E0E0E0",
                              margin: "10px 14px",
                              borderRadius: "6px",
                              padding: "12px",
                              background: "#fff",
                            }}
                          >
                            <Row>
                              <Col span={18} style={{ fontWeight: 600, color: "#0F0718", fontSize: "1em" }}>
                                {item?.productAliasName ? item?.productAliasName : item.name}
                              </Col>

                              <Col span={6} style={{ textAlign: "right", fontWeight: 600, marginBottom: 0 }}>
                                {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                                {item.nettotal}
                                {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol} ` : ""}
                              </Col>

                              <Col span={24}>
                                <p style={{ marginBottom: 0, fontSize: "0.9em", color: "#929098" }}>Quantity: {item.weight}</p>

                                <p
                                  style={{
                                    marginBottom: 4,
                                    marginTop: "0.5vh",
                                    fontWeight: 500,
                                    fontSize: "0.8em",
                                    color: "#929098",
                                  }}
                                >
                                  Assign to splits:
                                </p>

                                <div style={{ display: "flex", gap: "8px" }}>
                                  {[...Array(numSplits)].map((_, i) => {
                                    const isOn = itemSplitMap[item.lineId]?.[i] ?? true;
                                    return (
                                      <button
                                        key={i}
                                        onClick={() => handleToggleItemSplit(item, i)}
                                        style={{
                                          backgroundColor: isOn ? "#2F3856" : "#fff",
                                          color: isOn ? "#fff" : "#2F3856",
                                          border: "1px solid #2F3856",
                                          borderRadius: "20px",
                                          padding: "2.5px 10px",
                                          fontSize: "0.8em",
                                          cursor: "pointer",
                                        }}
                                      >
                                        Split {i + 1}
                                      </button>
                                    );
                                  })}
                                </div>
                              </Col>
                            </Row>
                          </div>
                        ))}
                      </>
                    )}
                  </div>
                ))}
              </div>
            </Scrollbars>
          </Col>
        ) : null}

        <Col span={18} style={{ padding: "0 15px" }}>
          <Row gutter={[8, 8]}>
            {/* {[...Array(numSplits)].map((_, splitIndex) => {
              const splitCart = splitCarts[splitIndex] || {}; */}
            {splitCarts.map((splitCart, splitIndex) => {
              return (
                <Col span={8} key={splitIndex}>
                  <div
                    style={{
                      background: "#fff",
                      height: "83vh",
                      width: "100%",
                      position: "relative",
                      fontSize: "1vw",
                      borderRadius: "5px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "2vh 1vw 0 1vw",
                      }}
                    >
                      <span
                        style={{
                          fontWeight: 600,
                          fontSize: "1.5em",
                          color: "#0F0718",
                          fontFamily: "Inter",
                        }}
                      >
                        {getMultilingualText("Order Details")}
                      </span>
                      <span style={{ fontWeight: 500, fontSize: "1em", color: "#929098" }}>{dayjs(splitCart.orderTime).format(userPreferences.dateFormat)}</span>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "0.5vh 1vw 0 1vw",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "0.9em",
                          color: "#0F0718",
                          fontWeight: 500,
                        }}
                      >
                        {useRestaurantStore.getState().dineIn === "Y" && splitCart?.tableNo && splitCart.tableNo} {splitCart?.documentno}
                      </span>
                      <span style={{ fontWeight: 500, fontSize: "1em", color: "#929098" }}>Split {splitCart.splitNo}</span>
                    </div>

                    <hr style={{ color: "#929098", width: "93%" }} />

                    <Scrollbars
                      autoHide
                      style={{
                        height: !showAllItems ? "41vh" : "50vh",
                      }}
                    >
                      <InfiniteScroll
                        dataLength={splitCart.items?.length || 0}
                        hasMore={true}
                        endMessage={
                          <p className="center">
                            <b>Yay! you have seen it all</b>
                          </p>
                        }
                        style={{ overflowX: "hidden" }}
                      >
                        {splitCart.items?.map((item) => (
                          <div key={item.lineId} style={{ padding: "12px" }}>
                            <div
                              style={{
                                fontSize: "1vw",
                                backgroundColor: selectedProductId === item.lineId ? "#f0f0f0" : "transparent",
                              }}
                            >
                              <Row>
                                <Col span={5}>
                                  <img
                                    src={item.imageurl || defaultImage}
                                    alt={item?.productAliasName ? item?.productAliasName : item.name}
                                    style={{
                                      height: item.description ? "10vh" : "8vh",
                                      width: "4vw",
                                      objectFit: "cover",
                                      borderRadius: "7px",
                                    }}
                                  />
                                </Col>
                                <Col span={16} style={{ display: "flex", flexDirection: "column", paddingLeft: "0.5vw" }}>
                                  <Text style={{ fontSize: "0.8em", color: "#0F0718", fontWeight: 500 }}>{item?.productAliasName ? item?.productAliasName : item.name}</Text>
                                  <Text style={{ fontSize: "0.5em", color: "#929098", fontWeight: 400 }}>{item.description}</Text>
                                  <Text style={{ fontWeight: 600, fontSize: "1em", color: "#0F0718" }}>
                                    {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                                    {toFixedTruncate(item.nettotal, pricePrecision)}
                                    {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
                                  </Text>
                                </Col>
                                <Col
                                  span={2}
                                  style={{
                                    textAlign: "center",
                                    color: "#0F0718",
                                    fontWeight: 500,
                                    fontSize: "0.8em",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  X {item.weight}
                                </Col>
                                <span
                                  style={{
                                    background: Math.abs(item.discount) > 0 ? "#F8C519" : "",
                                    borderRadius: "3px",
                                    padding: "0.25vw",
                                    display: item.discountName ? "" : "none",
                                    fontSize: "0.7em",
                                    marginTop: "1vh",
                                  }}
                                >
                                  {Math.abs(item.discount) > 0 && item.discountName && (
                                    <>
                                      <img src={Offers} alt="" width={12} height={12} style={{ marginTop: "-2px" }} /> {item.discountName}
                                    </>
                                  )}
                                </span>
                              </Row>
                            </div>
                          </div>
                        ))}
                      </InfiniteScroll>
                    </Scrollbars>

                    <div
                      style={{
                        padding: "1vh 0.6vw",
                        position: "absolute",
                        bottom: "1vh",
                        width: "100%",
                      }}
                    >
                      <Scrollbars autoHide style={{ height: "18vh" }}>
                        <Space
                          direction="vertical"
                          style={{
                            width: "100%",
                            background: "#F3F4F9",
                            padding: "1vh 0.5vw",
                            borderRadius: "10px",
                            rowGap: "4px",
                          }}
                        >
                          <Space style={{ width: "100%", justifyContent: "space-between" }}>
                            <Text style={{ fontSize: "0.8em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>{getMultilingualText("Subtotal")}</Text>
                            <Text style={{ fontSize: "0.8em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
                              {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                              {toFixedTruncate(splitCart?.total - splitCart?.tax, pricePrecision)}
                              {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
                            </Text>
                          </Space>

                          <Space style={{ width: "100%", justifyContent: "space-between" }}>
                            <Text style={{ fontSize: "0.8em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>{getMultilingualText("Discount Sales")}</Text>
                            <Text style={{ fontSize: "0.8em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
                              {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                              {toFixedTruncate(splitCart?.discount || 0, pricePrecision)}
                              {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
                            </Text>
                          </Space>

                          <Space style={{ width: "100%", justifyContent: "space-between" }}>
                            <Text style={{ fontSize: "0.8em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>{getMultilingualText("Total Sales Tax")}</Text>
                            <Text style={{ fontSize: "0.8em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
                              {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                              {toFixedTruncate(splitCart.tax, pricePrecision)}
                              {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
                            </Text>
                          </Space>

                          {serviceChargeAmount > 0 && (
                            <Space style={{ width: "100%", justifyContent: "space-between" }}>
                              <Text style={{ fontSize: "0.8em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>{getMultilingualText("Service Charge")}</Text>
                              <Text style={{ fontSize: "0.8em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
                                {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                                {toFixedTruncate(parseFloat(splitCart.serviceCharge || 0), pricePrecision)}
                                {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol} ` : ""}
                              </Text>
                            </Space>
                          )}
                          {tipTotal > 0 && (
                            <Space style={{ width: "100%", justifyContent: "space-between" }}>
                              <Text style={{ fontSize: "0.8em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>{getMultilingualText("Tip")}</Text>
                              <Text style={{ fontSize: "0.8em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
                                {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                                {toFixedTruncate(parseFloat(splitCart.tip || 0), pricePrecision)}
                                {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol} ` : ""}
                              </Text>
                            </Space>
                          )}
                          {deliveryCharge > 0 && (
                            <Space style={{ width: "100%", justifyContent: "space-between" }}>
                              <Text style={{ fontSize: "0.8em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>{getMultilingualText("Delivery Charge")}</Text>
                              <Text style={{ fontSize: "0.8em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
                                {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                                {toFixedTruncate(parseFloat(splitCart.deiveryCharge || splitCart.deliveryCharge || 0), pricePrecision)}
                                {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol} ` : ""}
                              </Text>
                            </Space>
                          )}
                          {packingCharge > 0 && (
                            <Space style={{ width: "100%", justifyContent: "space-between" }}>
                              <Text style={{ fontSize: "0.8em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>{getMultilingualText("Packing Charge")}</Text>
                              <Text style={{ fontSize: "0.8em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
                                {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                                {toFixedTruncate(parseFloat(splitCart.packingCharge || 0), pricePrecision)}
                                {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol} ` : ""}
                              </Text>
                            </Space>
                          )}

                          <Space style={{ width: "100%", justifyContent: "space-between", marginTop: "2px" }}>
                            <Text style={{ fontSize: "1em", fontWeight: 600, color: "#0F0718", fontFamily: "Inter" }}>{getMultilingualText("Total Amount")}</Text>
                            <Text style={{ fontSize: "1em", fontWeight: 600, color: "#0F0718", fontFamily: "Inter" }}>
                              {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                              {toFixedTruncate(
                                parseFloat(
                                  splitCart.total + (splitCart.deiveryCharge || splitCart.deliveryCharge || 0) + (splitCart.packingCharge || 0) + (splitCart.tip || 0) + (splitCart.serviceCharge || 0)
                                ),
                                pricePrecision
                              )}
                              {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
                            </Text>
                          </Space>
                        </Space>
                      </Scrollbars>
                      {!showAllItems && (
                        <div>
                          <Space direction="horizontal" style={{ paddingTop: "2vh" }}>
                            <Button
                              onClick={() => {
                                setPaymentVisible(true);
                                setRemoveSplit(splitCart);
                                setAmount(toFixedTruncate(parseFloat(splitCart.total || 0), pricePrecision));
                                setCart(splitCart);
                                const tablename = useRestaurantStore.getState().tableName;

                                const newSplitCartData = {
                                  ...recordState,
                                  documentno: splitCart.documentno,
                                  items: splitCart.items,
                                  uniqueId: uuidv4().replace(/-/g, "").toUpperCase(),
                                };
                                useRestaurantStore.getState().setTableName(newSplitCartData);
                              }}
                              style={{
                                width: "21vw",
                                borderRadius: "10px",
                                backgroundColor: "#2F3856",
                                color: "#fff",
                                height: "6vh",
                                fontSize: "1em",
                                fontWeight: 500,
                              }}
                            >
                              Pay Bill
                            </Button>
                          </Space>
                        </div>
                      )}
                    </div>
                  </div>
                </Col>
              );
            })}
            {/* })} */}
          </Row>
        </Col>
      </Row>
      {showAllItems ? (
        <Row style={{ marginTop: "1.3vh", display: "flex", justifyContent: "flex-end", padding: "0px 15px 0px 0px" }}>
          <Col span={4}>
            <Button
              style={{
                backgroundColor: "#2F3856",
                color: "#fff",
                fontSize: "1.2em",
                borderRadius: "5px",
                width: "100%",
                height: "5.5vh",
              }}
              onClick={() => {
                setShowAllItems(false);
                const tillDocumentSequence = useSessionStore.getState().documentSequence;
                const newDocumentSequence = tillDocumentSequence;
                useSessionStore.getState().setDocumentSequence(newDocumentSequence);
              }}
            >
              Done
            </Button>
          </Col>
        </Row>
      ) : null}
    </div>
  );
};

export default SplitBillScreen;
